import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DownloadPlanButton from './download-plan-button'
import DownloadPlanDialog from './download-plan-dialog'

const DownloadPlanHeaderAction = ({
  buttonLabel,
  dialogTitle,
  dialogDescription,
  onDownload,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <DownloadPlanButton label={buttonLabel} onClick={() => setOpen(true)} />
      <DownloadPlanDialog
        open={open}
        onClose={() => setOpen(false)}
        title={dialogTitle}
        description={dialogDescription}
        onDownload={onDownload}
      />
    </>
  )
}

DownloadPlanHeaderAction.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  dialogDescription: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
}

export default DownloadPlanHeaderAction
